import Moment from 'react-moment';

const NiceDate = (props) => {

return (
    <Moment format="DD-MMM-YYYY  HH:mm:ss">
      {props.children}
    </Moment>
  )
}

export default NiceDate;